'use strict';

const BaseModel = require('./baseModel');

class ContactNote extends BaseModel {
  constructor() {
    super(contactNoteSchema);
  }

  static getSchema() {
    return contactNoteSchema;
  }
}

const contactNoteSchema = {
  note: {
    required: {
      message: 'This field is required.'
    }
  }
};

module.exports = ContactNote;



// WEBPACK FOOTER //
// ./shared/models/contactNote.js